import clsx from "clsx";
import { useAtom } from "jotai";
import { useCallback, useEffect, useRef } from "react";
import useIsInViewport from "use-is-in-viewport";

import { cplEventsTracker } from "../../../shared/eventsTracker/events-tracker";
import { CplEventAction } from "../../../shared/eventsTracker/utils";
import {
  handleAssetUrl,
  handleGoogleDriveImageUrl,
} from "../../../shared/utils";
import { CplAtom, cplOfferPageAtom } from "../../cpl-offer-page.state";

export function CplTile({ id, index }: { id: string; index: number }) {
  const { newGridUI } = window.FKL;
  const [cplOfferPage] = useAtom(cplOfferPageAtom);
  const [cpl, setCpl] = useAtom(CplAtom(id));
  const cplTileRef = useRef<HTMLDivElement>(null);
  const [isInViewport, wrappedTargetRef] = useIsInViewport({
    target: cplTileRef,
    threshold: newGridUI ? 100 : 80,
  });

  const handleCplTileClick = () => {
    setCpl((cpl) => ({
      ...cpl,
      isAccepted: !cpl.isAccepted,
    }));
  };

  const cplImpressionSentToGA = useCallback(() => {
    setCpl((cpl) => ({
      ...cpl,
      gaImpressionSent: true,
    }));
  }, [setCpl]);

  useEffect(() => {
    if (!cpl.gaImpressionSent && (isInViewport || cpl.isAccepted)) {
      cplEventsTracker({
        cplName: cpl.name,
        action: CplEventAction.IMPRESSION,
        value: cpl.bid,
        email: cplOfferPage.emailReceiver,
      });
      cplImpressionSentToGA();
    }
  }, [
    isInViewport,
    cpl.gaImpressionSent,
    cpl.name,
    cpl.bid,
    cpl.isAccepted,
    cplOfferPage,
    cplImpressionSentToGA,
  ]);

  return (
    <div
      ref={wrappedTargetRef}
      role="button"
      tabIndex={index}
      className={clsx(
        "cpl-offer-page__tile",
        newGridUI && "cpl-offer-page-v2",
        cpl.isAccepted && "tile-selected"
      )}
      onClick={handleCplTileClick}
    >
      {newGridUI ? (
        <>
          <img
            src={handleGoogleDriveImageUrl(cpl.imageUrl)}
            alt="Cpl Img"
            className="cpl-offer-page__tile--image"
          />
          <div className="cpl-offer-page__tile--info">
            <img
              src={handleGoogleDriveImageUrl(cpl.logoUrl)}
              alt="Brand Logo"
              className="cpl-offer-page__tile--logo"
            />
            <div className="cpl-offer-page__tile--description">
              {cpl.description}
            </div>
            <div className="cpl-offer-page__tile--promo">{cpl.title}</div>
            <div className="cpl-offer-page__tile--times-picked-wrapper">
              <div className="cpl-offer-page__tile--times-picked">
                {cpl.timesPicked}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="cpl-offer-page__tile--title">
            <div className="cpl-offer-page__tile--title-icon-container">
              <img
                src={handleAssetUrl("heart_icon.png")}
                alt="Heart Icon"
                className="cpl-offer-page__tile--title-icon"
              />
            </div>
            {cpl.title}
          </div>
          <img
            src={handleGoogleDriveImageUrl(cpl.imageUrl)}
            alt="Cpl Img"
            className="cpl-offer-page__tile--image"
          />
          <div className="cpl-offer-page__tile--logo-container">
            <img
              src={handleGoogleDriveImageUrl(cpl.logoUrl)}
              alt="Brand Logo"
              className="cpl-offer-page__tile--logo"
            />
          </div>
          <div className="cpl-offer-page__tile--description">
            {cpl.description}
          </div>
        </>
      )}
    </div>
  );
}
